'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var LeftNavigationContext = React__default["default"].createContext(undefined);
var useLeftNavigationContext = function useLeftNavigationContext() {
  var context = React__default["default"].useContext(LeftNavigationContext);

  if (!context) {
    throw new Error('`useLeftNavigationContext` must be used within `LeftNavigationProvider`');
  }

  return context;
};
var LeftNavigationProvider = function LeftNavigationProvider(_ref) {
  var children = _ref.children,
      tabValue = _ref.tabValue,
      isUsingList = _ref.isUsingList;

  var _useState = React.useState(0),
      _useState2 = slicedToArray(_useState, 2),
      startingYPosition = _useState2[0],
      setStartingYPosition = _useState2[1];

  var _useState3 = React.useState({}),
      _useState4 = slicedToArray(_useState3, 2),
      collapsableState = _useState4[0],
      setCollapsableState = _useState4[1];

  var _useState5 = React.useState(tabValue),
      _useState6 = slicedToArray(_useState5, 2),
      currentTabValue = _useState6[0],
      setCurrentTabValue = _useState6[1];

  var setYPosition = function setYPosition(yPosition) {
    return setStartingYPosition(yPosition);
  };

  var setTabValue = function setTabValue(tabValue) {
    return setCurrentTabValue(tabValue);
  };

  var addCollapsableState = function addCollapsableState(collapsableItem) {
    setCollapsableState(_objectSpread({}, collapsableState, {}, collapsableItem));
  };

  var value = {
    startingYPosition: startingYPosition,
    setYPosition: setYPosition,
    collapsableState: collapsableState,
    addCollapsableState: addCollapsableState,
    setTabValue: setTabValue,
    currentTabValue: currentTabValue,
    isUsingList: isUsingList
  };
  return React__default["default"].createElement(LeftNavigationContext.Provider, {
    value: value
  }, children);
};

exports.LeftNavigationProvider = LeftNavigationProvider;
exports.useLeftNavigationContext = useLeftNavigationContext;
